import { render, staticRenderFns } from "./TabsTransfers.vue?vue&type=template&id=0e647fe6&"
import script from "./TabsTransfers.vue?vue&type=script&lang=js&"
export * from "./TabsTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports